export enum ApiRes {
  SUCCESS = "RXSUCCESS",
  ERROR = "RXERROR",
}

export type ProductTypeD = "chatbot";

export type SortD = "asc" | "desc" | "";
